
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DeviceSetupHeading from '../../../../components/Web/DeviceSetup/redesign/Components/deviceSetUpHeading';

const mapStateToProps = (state) => {
  const planDetails = state.homePlans ? state.homePlans.plansJson : {};
  const eligible5GHomeBundle = state.cartDetails?.cartDetailsJson?.orderDetailsView?.eligible5GHomeBundle || [];
  return {
    planDetails,
    eligible5GHomeBundle,
  };
};

function mapDispatchToProps() {

}
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withRouter(
  compose(
    // withSaga,
    withConnect
  )(DeviceSetupHeading),
);
